

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATESUBDEPARTMENT= createAsyncThunk(
  "createSubDepartment/createSubDepartment",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createSubDepartmentSlice = createSlice({
  name: "createSubDepartmentSlice",
  initialState: {
    createSubDepartment: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateSubDepartment: (state) => {
        state.createSubDepartment.loading = false
        state.createSubDepartment.error = false
        state.createSubDepartment.data = []
        state.createSubDepartment.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATESUBDEPARTMENT.fulfilled, (state, action) => {
      state.createSubDepartment = {
        ...state.createSubDepartment,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATESUBDEPARTMENT.pending, (state, action) => {
      state.createSubDepartment = {
        ...state.createSubDepartment,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATESUBDEPARTMENT.rejected, (state, action) => {
      state.createSubDepartment = {
        ...state.createSubDepartment,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createSubDepartmentAction = {
    CREATESUBDEPARTMENT,
};

export { createSubDepartmentAction };
export default createSubDepartmentSlice.reducer;
export const {setInitialStateOfcreateSubDepartment} = createSubDepartmentSlice.actions
